import { Component, ContentChild, EventEmitter, Input, Output, TemplateRef } from '@angular/core';

@Component({
    selector: 'app-table-column',
    template: ''
})
export class TableColumnComponent {
    @Input() cls: string;
    @Input() field: string;
    @Input() filter: boolean;
    @Input() showTree: boolean;
    @Input() header: string;
    @Input() sortable: string;
    @Input() filterPlaceholder: string;
    @Input() headerTooltip: string;
    @Input() withBackgroundColor = false;

    @Output() filterChange = new EventEmitter();

    @ContentChild('filter', {static: false}) filterTmpl: TemplateRef<any>;
    @ContentChild('body', {static: false}) bodyTmpl: TemplateRef<any>;
    @ContentChild('editor', {static: false}) editorTmpl: TemplateRef<any>;

    sort = {
        active: false,
        direction: ''
    };

    filterValue = '';

    updateSort() {
        const dir = this.sort.direction;
        this.sort = {
            active: true,
            direction: dir === 'asc' ? 'desc' : 'asc'
        };
    }

    onFilterChange() {
        this.filterChange.emit(this.filterValue);
    }

    clearSorting() {
        this.sort = {
            active: false,
            direction: ''
        };
    }
}
